// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"76889cef","232":"93ea1073","237":"b0ce2db2","526":"8ffb9249","787":"81017844","872":"53eed2da"}[chunkId] + ".chunk.js";
};